angular.module('homebot.directives')

  .directive('paidSoFarSection', ['Dictionary', 'HelperService', 'ChartService', '$rootScope', '$cookies', '$timeout', function(Dictionary, helpers, ChartService, $rootScope, $cookies, $timeout){
    return {
      bindToController: {
        agent: '=',
        loans: '='
      },
      controllerAs: 'paidCtrl',
      restrict: 'A',
      scope: {},
      templateUrl: '/homes/templates/section-paid-so-far.html',

      controller: function(){
        var loans;
        var dictionary = new Dictionary();
        var paidCtrl = this;
        var isFirstLoad = true;

        paidCtrl.hasCheckedNumbers = $cookies.get('hasCheckedNumbers');

        paidCtrl.lookup = function(prop,args,home){
          var home = {loans: loans};
          return dictionary[prop](home,args);
        };

        paidCtrl.update = function(){
          loans = _.isArray(paidCtrl.loans) ? paidCtrl.loans : [paidCtrl.loans];
          paidCtrl.chartistPaidSoFar = ChartService.chartistPaidSoFar([paidCtrl.lookup('principalPaidTotal'), paidCtrl.lookup('interestPaidTotal')]);

          if(isFirstLoad)
            updateFakeProperty();
        };

        $rootScope.$watch('subView', function(newVal){
          if(newVal === 'number-entry')
            paidCtrl.hasCheckedNumbers = true;
        });

        paidCtrl.shouldCheckNumbers = function(){
          if(!paidCtrl.lookup('unverifiedLoans').length)
            return false;
          else if(paidCtrl.hasCheckedNumbers)
            return false;
          else
            return true;
        };

        // Chartist no longer updates after the
        // pageload animation. This is a hack to
        // get chartist to update after the animation.
        // TODO fix this / get rid of chartist
        function updateFakeProperty(){
          $timeout(function(){
            paidCtrl.chartistPaidSoFar.options.fakePropertyForRefresh = 1;
            isFirstLoad = false;
          }, 1000);
        }

      },

      link: function($scope, el, attrs, paidCtrl){

        $scope.$watch('paidCtrl.hasCheckedNumbers', function(newVal){
          if(!helpers.isFalsey(newVal))
            $cookies.put('hasCheckedNumbers', true, {expires: moment().add(1, 'year').format()});
        });

        $scope.$watchCollection('paidCtrl.loans', function(newVal){
          paidCtrl.update();
        });
      }
    }
  }]);
